import { Box, Button, Dialog, DialogActions, Stack, Typography, Chip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { CancelOutlined, Publish, Unpublished } from "@mui/icons-material";

import { getTrimPublishStatusDisplay, trimsMasterColumnsObj } from "../data";
import { statusOptions } from "data/globalData";

const PublishModal = ({
	modal,
	setModal,
	mode = "publish",
	selectedRow,
	setSelectedRow,
	submitFunction = () => {},
	unpublishFunction = () => {},
}) => {
	const isUnpublish = mode === "unpublish";
	const statusDisplay = getTrimPublishStatusDisplay(selectedRow?.status);

	const handleClose = () => {
		setModal(false);
		if (typeof setSelectedRow === "function") setSelectedRow(null);
	};

	const handlePublishSubmit = async (status) => {
		await submitFunction(status);
		handleClose();
	};

	const handleUnpublishSubmit = async () => {
		await unpublishFunction();
		handleClose();
	};

	return (
		<Dialog fullWidth maxWidth="md" open={modal} onClose={handleClose} scroll="body">
			<Stack spacing={2} p={2}>
				<Box display="flex" alignItems="center" justifyContent="space-between" gap={1} flexWrap="wrap">
					<Typography variant="h6" fontWeight={800}>
						{isUnpublish ? "Unpublish Trim" : "Publish Trim"}
					</Typography>
					<Chip
						label={statusDisplay.label}
						sx={{
							fontWeight: 700,
							color: statusDisplay.color,
							bgcolor: statusDisplay.bgcolor,
						}}
					/>
				</Box>

				<Box
					sx={{
						border: `1px solid ${grey[200]}`,
						borderRadius: 2,
						p: 2,
						bgcolor: grey[50],
					}}>
					<Stack spacing={1.25}>
						<Typography variant="subtitle1" fontWeight={700}>
							Main Details
						</Typography>
						<Box display="flex" gap={2} flexWrap="wrap">
							<Typography variant="body2">
								Trim Code: <strong>{selectedRow?.[trimsMasterColumnsObj.trim_code.key] || "----"}</strong>
							</Typography>
							<Typography variant="body2">
								Brand: <strong>{selectedRow?.[trimsMasterColumnsObj.brand.key] || "----"}</strong>
							</Typography>
							<Typography variant="body2">
								Sub Category: <strong>{selectedRow?.[trimsMasterColumnsObj.item_sub_category.key] || "----"}</strong>
							</Typography>
						</Box>
						<Box>
							<Typography variant="body2" color={grey[700]}>
								{selectedRow?.[trimsMasterColumnsObj.item_description.key] || "No item description available."}
							</Typography>
						</Box>
						<Box display="flex" gap={2} flexWrap="wrap">
							<Typography variant="body2">
								{isUnpublish ? "Published By" : "Published By"}:{" "}
								<strong>{selectedRow?.[trimsMasterColumnsObj.published_by.key] || "----"}</strong>
							</Typography>
							<Typography variant="body2">
								{isUnpublish ? "Published Date" : "Published Date"}:{" "}
								<strong>{selectedRow?.[trimsMasterColumnsObj.published_date.key] || "----"}</strong>
							</Typography>
							<Typography variant="body2">
								Active: <strong>{selectedRow?.[trimsMasterColumnsObj.trim_active_status.key] || "INACTIVE"}</strong>
							</Typography>
						</Box>
					</Stack>
				</Box>

				<Box display="flex" gap={1} flexWrap="wrap" justifyContent="space-between" alignItems="center">
					<Typography variant="body2" color={grey[700]}>
						{isUnpublish
							? "Unpublishing will move the trim back to unpublished status. Active status will remain unchanged and editing will be enabled again."
							: "Publishing will set the final status and stamp the publish metadata."}
					</Typography>
					<Box display="flex" gap={1} flexWrap="wrap">
						{isUnpublish ? (
							<Button variant="contained" color="warning" startIcon={<Unpublished />} onClick={handleUnpublishSubmit}>
								Unpublish
							</Button>
						) : (
							<>
								<Button
									variant="outlined"
									startIcon={<CancelOutlined />}
									color="error"
									onClick={() => handlePublishSubmit(statusOptions.REJECTED.key)}>
									Reject
								</Button>
								<Button
									variant="contained"
									startIcon={<Publish />}
									onClick={() => handlePublishSubmit(statusOptions.PUBLISHED.key)}>
									Publish
								</Button>
							</>
						)}
					</Box>
				</Box>
			</Stack>
			<DialogActions>
				<Button variant="outlined" onClick={handleClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PublishModal;
